import React, { memo, useCallback, useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import styled from '@emotion/styled';
import { Color } from '@diritto/common/style/color';
import { ArrowTailIcon } from 'icons/ArrowTailIcon';

export const TopUp = memo(({ className, scrollThreshold = 200 }: { className?: string; scrollThreshold?: number }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsVisible(scrollPosition > scrollThreshold);
    };

    handleScroll();

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrollThreshold]);

  const handleClick = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <StyledTopUp className={className} onClick={handleClick}>
      <div
        className={twMerge(
          'inline-flex justify-center items-center',
          'w-11 h-11 p-2.5 bg-white rounded-[60px] outline outline-1 outline-offset-[-1px] outline-black/10',
          'pc:w-[58px] pc:h-[58px]',
        )}>
        <ArrowTailIcon color={Color.Gray900} />
      </div>
    </StyledTopUp>
  );
});

const StyledTopUp = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  cursor: pointer;

  right: 16px;
  bottom: 18px;
`;

TopUp.displayName = 'TopUp';
